<app-form-header class="backoffice-page-header"></app-form-header>
<mat-card>
  <div class="form-box">
    <form [formGroup]="formularioAbs">

      <div class="container"
           fxLayout
           fxLayout.xs="column"
           fxLayoutAlign="center"
           fxLayoutGap="10px"
           fxLayoutGap.xs="0">

        <mat-form-field appearance="outline">
          <mat-label>Aplicacion</mat-label>
          <input matInput formControlName="nombre" type="text" placeholder="Ingrese tipo de Aplicación"
                 [errorStateMatcher]="macherError">
          <mat-error *ngIf="f.nombre.hasError('required')">Debe ingresar el nombre del tipo de aplicación.</mat-error>
        </mat-form-field>

      </div>

      <div class="button-box" *ngIf="abm">
        <app-form-actions (primaryEmiter)="guardar()" (acentEmiter)="cancelar()"
                          (warnEmiter)="eliminar(formularioAbs.value)"
                          [hideBtnWarn]="!editar" [submitted]="submitted"></app-form-actions>
      </div>
    </form>


  </div>
</mat-card>
